module.exports = __webpack_public_path__ + "static/img/03xiexie.4f80543f.gif";